module.exports = __webpack_public_path__ + "static/media/upload.ad431d5e.svg";